import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ad562ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-3 pt-3 text-gray-800 dark:text-dark-text bg-white dark:bg-dark-800" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-wrap items-center justify-center my-5"
}
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "text-center flex-grow mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WarningText = _resolveComponent("WarningText")!
  const _component_ReviewDetailViewer = _resolveComponent("ReviewDetailViewer")!
  const _component_IconTextButton = _resolveComponent("IconTextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isAiReview(_ctx.entryId).value)
      ? (_openBlock(), _createBlock(_component_WarningText, {
          key: 0,
          text: _ctx.AIWARNTEXT
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ReviewDetailViewer, {
        entryId: _ctx.entryId,
        entryType: _ctx.entryType,
        index: _ctx.index
      }, null, 8, ["entryId", "entryType", "index"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.entryType === 'OPEN')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_IconTextButton, {
              border_radius: 2,
              class: "mx-1 my-1",
              font_weight: '700',
              icon: 'thumb_up_alt',
              iconColor: 'text-green-400',
              iconSize: 'text-xl',
              padding_bottom: 4,
              padding_left: 12,
              padding_right: 12,
              padding_top: 4,
              text: '5',
              textSize: 'text-base',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickEvaluationReview(_ctx.reviewId, 5)))
            }),
            _createVNode(_component_IconTextButton, {
              border_radius: 2,
              class: "mx-1 my-1",
              font_weight: '700',
              icon: 'thumb_up_alt',
              iconSize: 'text-xl',
              padding_bottom: 4,
              padding_left: 12,
              padding_right: 12,
              padding_top: 4,
              text: '4',
              textSize: 'text-base',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickEvaluationReview(_ctx.reviewId, 4)))
            }),
            _createVNode(_component_IconTextButton, {
              border_radius: 2,
              class: "mx-1 my-1",
              font_weight: '700',
              icon: 'thumbs_up_down',
              iconSize: 'text-xl',
              padding_bottom: 4,
              padding_left: 12,
              padding_right: 12,
              padding_top: 4,
              text: '3',
              textSize: 'text-base',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickEvaluationReview(_ctx.reviewId, 3)))
            }),
            _createVNode(_component_IconTextButton, {
              border_radius: 2,
              class: "mx-1 my-1",
              font_weight: '700',
              icon: 'thumb_down_alt',
              iconSize: 'text-xl',
              padding_bottom: 4,
              padding_left: 12,
              padding_right: 12,
              padding_top: 4,
              text: '2',
              textSize: 'text-base',
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickEvaluationReview(_ctx.reviewId, 2)))
            }),
            _createVNode(_component_IconTextButton, {
              border_radius: 2,
              class: "mx-1 my-1",
              font_weight: '700',
              icon: 'thumb_down_alt',
              iconColor: 'text-red-400',
              iconSize: 'text-xl',
              padding_bottom: 4,
              padding_left: 12,
              padding_right: 12,
              padding_top: 4,
              text: '1',
              textSize: 'text-base',
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickEvaluationReview(_ctx.reviewId, 1)))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.entryType === 'OPEN')
          ? (_openBlock(), _createBlock(_component_IconTextButton, {
              key: 0,
              border_radius: 2,
              font_weight: '700',
              icon: 'cancel',
              iconSize: 'text-2xl',
              padding_bottom: 4,
              padding_left: 12,
              padding_right: 12,
              padding_top: 4,
              text: _ctx.$t(`message.closeEntry`),
              textSize: 'text-base',
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clickCloseEntry()))
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}